import React, { useState } from 'react'
import {Input, Button, message} from 'antd'
import { getEnv } from "../../../helpers/mobx-easy-wrapper";


interface IVerifyCodeProps {
    value?: any
    onChange?: (value: any) => void
    readyPost?: boolean
    phoneNumber?: number
    style?: React.CSSProperties
}

export const VerifyCode: React.FC<React.PropsWithChildren<IVerifyCodeProps>> =
    ({ value, onChange, readyPost, phoneNumber, ...props }) => {
        const [lastTime, setLastTime] = useState(0)
        const { apiFactory } = getEnv();
        const counting = (time = 60) => {
            const remainingTime = apiFactory.authService.getVcodeTimestamp();
            console.log('remainingTime', remainingTime);
            if (time < 0) return
            setLastTime(time)
            setTimeout(() => {
                counting(time - 1)
            }, 1000)
        }
        const sendCode = async (phone:string) =>{
            const remainingTime = apiFactory.authService.getVcodeTimestamp();

            if (remainingTime > 0) {
                return;
            }
            try {
                await apiFactory.authService.sendVcode(phone);
                message.success("发送成功");
            } catch (e) {
                message.error("发送失败");
            }
        }

        return (
            <div
                style={{ display: 'inline-flex', width: '100%', alignItems: 'center' }}
            >
                <Input
                    {...props}
                    style={{ marginRight: 5, ...props.style }}
                    value={value}
                    onChange={onChange}
                />
                <div
                    style={{
                        flexShrink: 0,
                        color: '#999',
                        width: 100,
                        height: 35,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {lastTime === 0 && (
                        <Button
                            disabled={!readyPost}
                            block
                            onClick={() => {
                                if (phoneNumber) {
                                   sendCode(phoneNumber + '');
                                }
                                counting()
                            }}
                        >
                            发送验证码
                        </Button>
                    )}
                    {lastTime > 0 && <span>剩余{lastTime}秒</span>}
                </div>
            </div>
        )
    }